import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "5f28d047-eb9c-4ddc-bb93-cd801b0c5750", // ✅ SPA client ID (unchanged)
    authority:
      "https://login.microsoftonline.com/13e57fe2-c99a-4bfc-b97f-ccac26820e89",
    redirectUri: "https://bdm.bcomsat.com",
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "api://5f28d047-eb9c-4ddc-bb93-cd801b0c5750/access_as_user", // ✅ ONLY THIS CHANGES
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
